let backgroundRoutePrefetchDepth = 0;

/** True while an idle route prefetch dynamic import is in flight. */
export function isBackgroundRoutePrefetchImport() {
  return backgroundRoutePrefetchDepth > 0;
}

/** Wrap background prefetch imports so stale-chunk preload errors do not reload the tab. */
export function withBackgroundRoutePrefetchImport(work) {
  backgroundRoutePrefetchDepth += 1;
  return Promise.resolve()
    .then(work)
    .finally(() => {
      backgroundRoutePrefetchDepth -= 1;
    });
}
